import styled from 'styled-components'

export const BottomContent = styled.div`
  padding-bottom: 10px;
`
